<template >
<div>
      <div >
    <CModal :show="cookies"  fullHeight position="center" :size="sm">
        <CModalHeader center :close="true" slot="header" class="p-0 m-0">
            <p class="heading m-0"><mdb-icon icon="exclamation-circle" class="icono-error m-2" /> Information </p>
          </CModalHeader>
      <mdb-modal-body class="text-center">
          <p class="center">{{message}}</p>
      </mdb-modal-body>
      <CModalFooter center slot="footer" class="m-0">
        <CButton color="primary" @click="closeModel()">OK</CButton>
      </CModalFooter>
    </CModal>
  </div>

  <section class="preview model-content">
    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->
      <CRow>
        <CCol>
          <mdb-input
            placeholder="Nombre"
            class="mb-3 mt-0"
            v-model="name"
            required
            invalidFeedback="Coloca el nombre"
          >
            <span class="input-group-text md-addon" slot="prepend">Nombre Segmentación</span>
          </mdb-input>

          <div class="form-group">
            <label class="typo__label">Genero</label>
            <multiselect
              v-model="genderSelected"
              deselect-label
              placeholder="Seleccione el genero"
              track-by="id"
              label="name"
              :options="genders"
              :searchable="false"
              :allow-empty="false"
            ></multiselect>
          </div>

          <div class="form-group">
            <label class="typo__label">Tipo de conexion</label>
            <multiselect
              v-model="conectionTypeSelected"
              placeholder="tipo de conexión"
              label="name"
              track-by="id"
              :options="conectionTypes"
              :multiple="false"
            ></multiselect>
          </div>

          <div class="form-group">
            <label class="typo__label">Edad mínima</label>
            <input
              type="number"
              class="form-control"
              placeholder="edad min"
              v-model="minAge"
              min="13"
            />
          </div>

          <div class="form-group">
            <label class="typo__label">Edad máxima</label>
            <input
              type="number"
              class="form-control"
              placeholder="edad maxima"
              v-model="maxAge"
              min="13"
            />
          </div>
        </CCol>

        <CCol>
          <div class="form-group">
            <!-- <CInputCheckbox
          v-model="ubicacionRecomendada"
          name="checkbox-1"
          label="Ubicaciones recomendadas"
          @change="checkboxUpdate(ubicacionRecomendada)"
            />-->
            <div class="ml-2">
              <input type="checkbox" class="form-check-input" v-model="ubicacionRecomendada" />
              <lable class="form-checl-lable">Ubicaciones recomendadas</lable>
            </div>

            <!-- </div> -->

            <div v-if="!ubicacionRecomendada">
              <div class="form-group">
                <label class="typo__label">Sistemas Operativos</label>
                <multiselect
                  v-model="os_selected"
                  placeholder="Sistemas Operativos"
                  label="name"
                  track-by="id"
                  :options="os"
                  :multiple="true"
                ></multiselect>
              </div>

              <div class="form-group">
                <label class="typo__label">Tipo de dispositivos</label>
                <multiselect
                  v-model="device"
                  placeholder="tipo de dispositivos"
                  label="name"
                  track-by="id"
                  :options="devices"
                  :multiple="true"
                ></multiselect>
              </div>

              <div class="form-group">
                <label class="typo__label">Plataformas de publicación</label>
                <multiselect
                  v-model="platform"
                  placeholder="Plataformas de publicación"
                  label="name"
                  track-by="id"
                  :options="platforms"
                  :multiple="true"
                ></multiselect>
              </div>

              <div class="form-group">
                <label class="typo__label">Posición de la publicación</label>
                <multiselect
                  v-model="positon_selected"
                  placeholder="Posición de la publicación"
                  label="name"
                  track-by="id"
                  :options="positions"
                  :multiple="true"
                ></multiselect>
              </div>
            </div>
            <!--<div class="form-group">
                  <label class="typo__label">Intereses</label>
                  <multiselect
                    v-model="interestsSelected"
                    :options="interests"
                    @search-change="getInterests"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    
                  </multiselect>
            </div>-->

            <!-- <div class="form-group">
                  <label class="typo__label">Audiencias personalizadas a incluir</label>
                  <multiselect
                    v-model="audienciasSelectedInclude"
                    :options="audiencias"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    
                  </multiselect>
            </div>-->

            <!-- <div class="form-group">
                  <label class="typo__label">Audiencias personalizadas a excluir</label>
                  <multiselect
                    v-model="audienciasSelectedExclude"
                    :options="audiencias"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecciona intereses"
                    label="name"
                    track-by="id"
                    :preselect-first="false"
                  >
                    
                  </multiselect>
            </div>-->
          </div>

          <div class="text-center">
            <mdb-btn type="submit" color="primary" :disabled="isLoading">
              <span v-if="!isLoading">Crear</span>
              <semipolar-spinner
                :animation-duration="2000"
                :size="30"
                color="#ffffff"
                v-if="isLoading"
              ></semipolar-spinner>
            </mdb-btn>
          </div>
        </CCol>
      </CRow>
    </form>
  </section>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip,
} from "mdbvue";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbIcon,
    mdbTextarea,
    mdbTooltip,
  },
  props: {
    onClick: Function,
  },
  data: () => {
    return {
      isLoading: false,
      modal: false,
      name: "",
      genderSelected: {},
      genders: [
        //4th tab
        { name: "Hombre", id: 1 },
        { name: "Mujer", id: 2 },
        { name: "Ambos", id: 3 },
      ],
      devices: [
        //4th tab
        { name: "Mobile", id: 1 },
        { name: "Desktop", id: 2 },
      ],
      device: [],
      platforms: [],
      platform: [],
      conectionTypeSelected: {},
      conectionTypes: [
        { name: "Wi-fi", id: 1 },
        { name: "3G/4G", id: 2 },
        { name: "Todos", id: 3 },
      ],
      interestsSelected: [],
      interests: [],
      minAge: 18,
      maxAge: 65,
      ubicacionRecomendada: false,
      dateStart: "",
      dateEnd: "",
      lines: [],
      linesSelected: [],
      stereotypes: [],
      stereotypesSelected: [],
      promotions: [],
      audiencias: [],
      promotionSelected: [],
      // audienciasSelectedInclude: [],
      // audienciasSelectedExclude: [],
      nameLine: "",
      descriptionLine: "",
      os: [1, 2, 3],
      os_selected: [],
      positions: [],
      positon_selected: [],
      isLoadingLine: false,
      cookies:false,
      message:"",
    };
  },
  async mounted() {
    //await this.getInterests();
    var respuesta = await this.getStereotypes();
    respuesta = await this.getOS();
    // respuesta = await this.getPromotions();
    // respuesta = await this.getAudiencias();
    respuesta = await this.getPlatform();
    respuesta = await this.getPositions();
  },
  methods: {
    checkboxUpdate(t) {
      this.ubicacionRecomendada = t.target.checked;
      console.log(this.ubicacionRecomendada);
    },
    async getPositions() {
      var positions = store.getters.getPositions;
      if (positions.length == 0) {
        await store.dispatch("getPositions").then(() => {
          positions = store.getters.getPositions;
          this.positions = positions;
        });
      } else {
        this.positions = positions;
      }
    },
    async getPlatform() {
      var platforms = store.getters.getPlatform;
      if (platforms.length == 0) {
        await store.dispatch("getPlatform").then(() => {
          platforms = store.getters.getPlatform;
          this.platforms = platforms;
        });
      } else {
        this.platforms = platforms;
      }
    },
    async getOS() {
      var os = store.getters.getOs;
      console.log("OS :::", os);
      if (os.length == 0) {
        store.dispatch("getOs").then(() => {
          os = store.getters.getOs;
          console.log("@@@@@", os);
          this.os = os;
          // os.forEach((i) => {
          //   this.os.push(i);
          //   // this.os_selected.push(i.platform);
          // });
        });
      } else {
        this.os = os;
        // os.forEach((i) => {
        //   this.os.push(i.platform);
        //   // this.os_selected.push(i.platform);
        // });
      }
    },
    async getInterests(searchQuery = "") {
      await store.dispatch("getInterests", searchQuery).then(() => {
        var interests = store.getters.getInterests;
        this.interests = interests;
        return;
      });
    },
    async getStereotypes() {
      var stereotypes = store.getters.getStereotypes;
      if (stereotypes.length == 0) {
        store.dispatch("getStereotypes").then(() => {
          stereotypes = store.getters.getStereotypes;
          this.stereotypes = stereotypes;
        });
      } else {
        this.stereotypes = stereotypes;
      }
    },
    async getPromotions() {
      var promotions = store.getters.getPromotions;
      if (promotions.length == 0) {
        store.dispatch("getPromotions").then(() => {
          promotions = store.getters.getPromotions;
          this.promotions = promotions;
        });
      } else {
        this.promotions = promotions;
      }
    },
    async getAudiencias() {
      var audiencias = store.getters.getAudiencias;
      if (audiencias.length == 0) {
        store.dispatch("getAudiencias").then(() => {
          audiencias = store.getters.getAudiencias;
          this.audiencias = audiencias;
        });
      } else {
        this.audiencias = audiencias;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
        genderSelected,
        maxAge,
        minAge,
        ubicacionRecomendada,
        name,
        // audienciasSelectedInclude,
        // audienciasSelectedExclude,
        conectionTypeSelected,
        os_selected,
        device,
        platform,
        positon_selected,
      } = this;
      this.isLoading = true;
      if (name == "") {
        this.isLoading = false;
      } else {
        // var custom_audience_ids = [];
        // audienciasSelectedInclude.map((i) => {
        //   custom_audience_ids.push(i.id);
        // });
        // var exclude_audience_ids = [];
        // audienciasSelectedExclude.map((i) => {
        //   exclude_audience_ids.push(i.id);
        // });

        var os_ids = [];
        os_selected.map((i) => {
          os_ids.push(i.id);
        });

        var device_platforms_ids = [];
        device.map((i) => {
          device_platforms_ids.push(i.id);
        });

        var publisher_platforms_ids = [];
        platform.map((i) => {
          publisher_platforms_ids.push(i.id);
        });

        var position_ids = [];
        positon_selected.map((i) => {
          position_ids.push(i.id);
        });

        var stereotype = {
          gender: genderSelected.id,
          conectionType:conectionTypeSelected.id,
          age_max: maxAge,
          age_min: minAge,
          recommended_locations: ubicacionRecomendada,
          name,
          wireless_carrier: conectionTypeSelected.id,
          // custom_audience_ids,
          // exclude_audience_ids,
          os_ids,
          device_platforms_ids,
          publisher_platforms_ids,
          position_ids,
          genderSelected,
          conectionTypeSelected,
          positon_selected,
          platform,
          device,
          os_selected,
          // audienciasSelectedExclude,
          // audienciasSelectedInclude
        };
        store.dispatch("newStereotype", stereotype).then((res) => {
          /*this.name = "";
          this.description = "";
          this.dateStart = "";
          this.dateEnd = "";
          this.linesSelected = [];*/
          
        
          // this.onClick();
          this.cookies=true;
          this.message="Estrategia de segmentación creada correctamente";
          this.isLoading = false;
        });
      }
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var line = {
          nameLine,
          descriptionLine,
        };
        store.dispatch("newLine", line).then(() => {
          this.nameLine = "";
          this.descriptionLine = "";
          this.isLoadingLine = false;
          this.modal = false;
        });
      }
    },

    closeModel(){
      this.cookies=false;

      // this.$router.push({ path: `segmentationstrategies` });

      this.onClick();
      location.reload();

    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  /*bottom: 80px;*/
}
.modal-content {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 168% !important;
  pointer-events: auto;
  background-clip: padding-box;
  border: 1px solid;
  border-radius: 0.3rem;
  outline: 0;
  background-color: #fff;
  border-color: rgba(0, 0, 21, 0.2);
}
</style>